import React, { useState } from 'react';
import styled from 'styled-components';
import { useImageUrl } from '../../hooks/useImageUrl';

const Image = styled.img`
  width: 90px;
  height: 90px;
  object-fit: cover;
  border-radius: 1.25rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  background: #f3f4f6;
`;

const Placeholder = styled.div`
  width: 90px;
  height: 90px;
  border-radius: 1.25rem;
  background: #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  color: #9ca3af;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  
  i {
    font-size: 2.5rem;
  }
`;

interface ProductImageProps {
  imageId: string;
  alt: string;
  onClick?: (e: React.MouseEvent) => void;
}

export const ProductImage: React.FC<ProductImageProps> = ({ imageId, alt, onClick }) => {
  const imageUrl = useImageUrl(imageId);
  const [hasError, setHasError] = useState(false);

  if (!imageId || !imageUrl || hasError) {
    return null;
  }

  return (
    <Image 
      src={imageUrl} 
      alt={alt}
      onError={() => setHasError(true)}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    />
  );
};
